import React from 'react';
import Gallery from '../components/Gallery';
import { babyShootsImages } from '../data/images';

const BabyShoots = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Baby Shoots</h1>
          <p>
            Adorable baby photography sessions capturing precious moments and milestones with gentle, loving care. 
            From newborns to toddlers, we preserve the most precious memories of your little ones.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={babyShootsImages} sectionId="baby-shoots" />
        </div>
      </section>

    </div>
  );
};

export default BabyShoots;
